import React, { FC } from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { RecommendProductItem } from '../../hooks/types';
import { useLang } from '@/i18n';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import gtm from '@/utils/gtm';
import BlackButton from '../BlackButton';

interface ProductCardProps {
    product: RecommendProductItem;
}

const ProductCard: FC<ProductCardProps> = ({ product }) => {
    const { t } = useLang('RecommendList');
    const { locale = 'us' } = useRouter();
    const hasDiscount = product.compareAtPrice > product.price;
    const btnId = `service-renewal-recommend-list-buy-now-${product.productId}`;

    const handleBuyNow = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: t('buy_now'),
            __btn_id1: btnId,
            __btn_id2: btnId,
            __btn_type: 'common',
            __bth_only_ef: true,
        });
        // window.open(`https://${locale}.ecoflow.com/products/${product.handle}?variant=${product.variantId}`, '_blank');
        window.open(`https://${locale}.ecoflow.com/cart/${product?.variantId}:1?channel=buy_button`, '_blank');
    };

    return (
        <div className={styles['recommend-list__product-card']}>
            <div className={styles['recommend-list__product']}>
                <div className={styles['recommend-list__product-image']}>
                    <img src={product.variantImg || product.img} alt={product.productTitle} loading="lazy" />
                </div>
                <div className={styles['recommend-list__product-info']}>
                    <p className={styles['recommend-list__product-title']} title={product.productTitle}>
                        {product.productTitle}
                    </p>
                    <div className={styles['recommend-list__product-price-wrap']}>
                        <div className={styles['recommend-list__product-price']}>
                            <span className={styles['recommend-list__product-price-current']}>{FormatMoneyLocal(product.price, locale)}</span>
                            {hasDiscount && (
                                <span className={styles['recommend-list__product-price-compare']}>{FormatMoneyLocal(product.compareAtPrice, locale)}</span>
                            )}
                        </div>
                        <BlackButton
                            className={`${styles['recommend-list__product-buy-btn']} GtmModuleData-btn-common ${btnId}`}
                            data-btn-id={btnId}
                            type="primary"
                            shape="round"
                            onClick={handleBuyNow}
                        >
                            {t('buy_now')}
                        </BlackButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
